import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";
import * as ErrorMessage from "~/ErrorMessage";
import * as Typography from "~/Typography";

type Props = ErrorMessage.ErrorMessage & { readonly sup?: boolean };

export const Component: React.Fn<Props> = ({ children, ...props }) => (
  <Circle.Component {...props}>
    <Typography.Component strong>{children}</Typography.Component>
  </Circle.Component>
);

namespace Circle {
  export const Component = styled.span<Props>`
    display: inline-block;
    padding: 0.06em 0.53em;
    border-radius: 10em;

    background-color: ${({ danger, warning }) =>
      danger
        ? ErrorMessage.Danger.color()
        : warning
        ? ErrorMessage.Warning.color()
        : Color.steel()};

    color: ${({ danger, warning }) =>
      danger || !warning ? Color.white() : Color.black()};
  `;
}
